module.exports = __webpack_public_path__ + "static/media/atlasBHRILogoCompleto.517936f1.svg";